/* eslint-disable relay/unused-fields */
import { useToggle } from "@react-hookz/web";
import first from "lodash/first";
import { type FunctionComponent, useCallback } from "react";
import { graphql, useFragment } from "react-relay";

import { notEmpty } from "shared/lib/utils";

import { SearchResultListToggle } from "scmp-app/components/search/search-result-panel/search-result-list/search-result-list-toggle";
import type { videoSectionSearchResultListVideoSectionSearchEdge$key } from "scmp-app/queries/__generated__/videoSectionSearchResultListVideoSectionSearchEdge.graphql";

import { Container, StyledVideoSectionSearchResultListItem, Title } from "./styles";

export type Props = {
  className?: string;
  reference: videoSectionSearchResultListVideoSectionSearchEdge$key;
};

export const VideoSectionSearchResultList: FunctionComponent<Props> = ({
  className,
  reference,
}) => {
  const videoSections = useFragment(
    graphql`
      fragment videoSectionSearchResultListVideoSectionSearchEdge on VideoSectionSearchEdge
      @relay(plural: true) {
        node {
          score
          content {
            __typename
            entityId
            ...itemVideoSectionSearchResultListItemVideoSection
          }
        }
      }
    `,
    reference,
  );

  const [isExpand, toggleIsExpand] = useToggle();

  const renderItems = useCallback(() => {
    if (isExpand) {
      return videoSections?.map(
        ({ node }) =>
          notEmpty(node.content) && (
            <StyledVideoSectionSearchResultListItem
              key={node.content.entityId}
              reference={node.content}
            />
          ),
      );
    }
    const firstItem = first(videoSections)?.node;
    return (
      notEmpty(firstItem?.content) && (
        <StyledVideoSectionSearchResultListItem reference={firstItem.content} />
      )
    );
  }, [isExpand, videoSections]);

  return (
    notEmpty(videoSections) && (
      <Container className={className}>
        <Title>Video Section:</Title>

        {renderItems()}

        {videoSections.length > 1 && (
          <SearchResultListToggle
            isExpand={isExpand}
            onClick={() => toggleIsExpand()}
            toggleMessage={{
              after: "Show less",
              before: "Show all video sections",
            }}
          />
        )}
      </Container>
    )
  );
};

VideoSectionSearchResultList.displayName = "VideoSectionSearchResultList";
